import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { backendURL } from 'src/constant/api/backendURL';
import Cookies from 'js-cookie';

export const fetchHeroImage = createAsyncThunk('heroImage/fetch', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${backendURL}/hero-image`);
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response?.data?.message || 'Failed to fetch hero image');
  }
});

const heroImageSlice = createSlice({
  name: 'heroImage',
  initialState: {
    heroImageUrl: null as string | null,
    id: null as string | null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHeroImage.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchHeroImage.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.heroImageUrl = action.payload.heroImageUrl;
        state.id = action.payload.id;
      })
      .addCase(fetchHeroImage.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      });
  },
});

export default heroImageSlice.reducer;
